<template>
	<div class="header-wrap">
		<header class="header">
			<div class="header-wrap-new">
				<div class="one"></div>
				<div class="two">
					<router-link to="/" class="logo"><img
							alt="OCM Globe Inc - Asian food wholesale USA, 亚洲食品批发 - 美国华源食品集团"
							src="@/assets/images/logowithletter.png" title="Food Products Wholesaler | Ocm Foods">
					</router-link>
					<nav class="nav">
						<a href="javascript:;" @click="jumpTo(item)" v-for="(item,index) in $t('navList')"
							:key="index" class="nav-item">
							{{ item.title }}
						</a>
					</nav>
				</div>
				<div class="three">
					<div class="tools">
						<div v-for="(item,index) in $t('shareList')" :key="index" :class="item.name"
							class="share-item" @click="clickShare(item)">
							<img :src="item.img" :alt="item.name">
						</div>
						<div class="lang notranslate" @click="changeLang">{{$t('lang')}}</div>
						<div class="set" :title="$t('policy.txt1')">
							<img alt="set cookies" src="@/assets/images/set.svg"
								class="termly-cookie-preference-button" onclick="displayPreferenceModal()">
						</div>
					</div>
					<!-- <div class="goto-site">Go to <a href="https://www.lervgroup.com" target="_blank"><strong
								class="lvg">Ler V
								Group</strong></a> Site
					</div> -->
				</div>
			</div>
			<div class="header-wp">
				<router-link to="/" class="logo"><img
						alt="OCM Globe Inc - Asian food wholesale USA, 亚洲食品批发 - 美国华源食品集团"
						src="@/assets/images/logo.svg" title="Food Products Wholesaler | Ocm Foods">
				</router-link>
				<div class="hd-r" :class="showHdr ? 'show' : ''">
					<nav class="nav">
						<a href="javascript:;" @click="jumpTo(item)" v-for="(item,index) in $t('navList')"
							:key="index" class="nav-item">
							{{ item.title }}
						</a>
					</nav>
					<!-- <div id="google_translate_element"></div> -->
					<div class="tools">
						<div v-for="(item,index) in $t('shareList')" :key="index" :class="item.name"
							class="share-item" @click="clickShare(item)">
							<img :src="item.img" :alt="item.name">
						</div>
						<div class="lang notranslate" @click="changeLang">{{$t('lang')}}</div>
						<!-- <div class="set">
							<img alt="set cookies" src="@/assets/images/set.svg">
						</div> -->
					</div>
				</div>
				<div class="menuBtn" @click="showHdr = !showHdr" :class="showHdr ? 'open' : ''"></div>
				<div class="lang forMobile notranslate" @click="changeLang">{{$t('lang')}}</div>
			</div>
		</header>
		<!--        微信，小红书弹窗-->
		<qrPop v-if="showWxPop" :pop-data="$t('wxData')" @close="showWxPop = false" />
		<qrPop v-if="showXhsPop" :pop-data="$t('xhsData')" @close="showXhsPop = false" />

		<cookiePop v-if="showCooikePop" @close="showCooikePop = false" />
	</div>
</template>

<script>
import qrPop from "@/components/qrPop";
import cookiePop from "@/components/cookiePop";
export default {
	name: "pageHeader",
	components: {
		qrPop, cookiePop
	},
	data() {
		return {
			showHdr: false,
			showCooikePop: false,
			showWxPop: false,
			showXhsPop: false,
		};
	},
	methods: {
		clickShare(item) {
			if (item.event === 'showWx') {
				this.showWxPop = true;
			}
			if (item.event === 'showXhs') {
				this.showXhsPop = true;
			}
			if (item.event === 'link') {
				window.open(item.path, 'blank');
			}
		},
		// updateLanguage(value) {
		// 	const a = document.querySelector('#google_translate_element select');
		// 	const html = document.querySelector('html');
		// 	if (value === 'en') {
		// 		html.removeAttribute('translate');
		// 		a.value = 'en';
		// 		a.dispatchEvent(new Event('change'));
		// 	}
		// 	if (value === 'zh') {
		// 		html.setAttribute('translate', 'no');
		// 		a.value = 'zh-CN';
		// 		a.dispatchEvent(new Event('change'));
		// 	}
		// },
		changeLang() {
			let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
			this.$i18n.locale = lang;
			sessionStorage.setItem('lang', lang);
			// this.updateLanguage(lang);
		},
		jumpTo(item) {
			this.$router.push(item.path);
			this.showHdr = false;
		}
	}
}
</script>

<style scoped lang="scss">
//header
.header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 999;
	background-color: #fff;
	padding: 20px 0 24px;
	.header-wrap-new {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		.one {
			grid-column: 1;
		}
		.two {
			grid-column: 2;
			text-align: center;
			.logo {
				img {
					height: 36px;
					width: auto;
				}
			}
			.nav {
				margin-top: 20px;
				display: flex;
				justify-content: center;
				.nav-item {
					@extend .semibold-16px;
					cursor: pointer;
					-webkit-transition: all 0.3s;
					-moz-transition: all 0.3s;
					-ms-transition: all 0.3s;
					-o-transition: all 0.3s;
					transition: all 0.3s;
				}
				.nav-item:hover {
					color: $activeColor;
				}
				.nav-item + .nav-item {
					margin-left: 40px;
				}
			}
		}
		.three {
			grid-column: 3;
			text-align: right;
			.tools {
				display: flex;
				align-items: center;
				justify-content: flex-end;
				.share-item {
					width: 20px;
					height: 20px;
					cursor: pointer;
					img {
						display: block;
						height: 100%;
						width: auto;
					}
					&.xhs {
						width: 36px;
						height: 36px;
						margin-left: 10px !important;
					}
				}
				.share-item + .share-item {
					margin-left: 8px;
				}
				.lang {
					margin: 0 20px 0 20px;
					text-transform: capitalize;
					cursor: pointer;
					@extend .regular-14px;
				}
				.set {
					height: 18px;
					margin-right: 30px;
					cursor: pointer;
					img {
						display: block;
						height: 100%;
						width: auto;
					}
				}
			}
			.goto-site {
				@extend .semibold-16px;
				margin: 22px 30px 0 0;
			}
			.lvg {
				transition: all 0.3s;
			}
			.lvg:hover {
				color: $activeColor;
			}
		}
	}
	.header-wp {
		padding: 0 40px;
		display: none;
		// display: flex;
		align-items: center;
		.logo {
			height: 36px;
			margin-right: 60px;
			img {
				display: block;
				height: 100%;
				width: auto;
			}
		}
		.hd-r {
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.nav {
				display: flex;
				align-items: center;
				.nav-item {
					@extend .semibold-16px;
					cursor: pointer;
					-webkit-transition: all 0.3s;
					-moz-transition: all 0.3s;
					-ms-transition: all 0.3s;
					-o-transition: all 0.3s;
					transition: all 0.3s;
				}
				.nav-item:hover {
					color: $activeColor;
				}
				.nav-item + .nav-item {
					margin-left: 40px;
				}
			}
			.tools {
				display: flex;
				align-items: center;
				.share-item {
					width: 25px;
					height: 25px;
					cursor: pointer;
					img {
						display: block;
						height: 100%;
						width: auto;
					}
					&.xhs {
						width: 36px;
						height: 36px;
						margin-left: 10px !important;
					}
				}
				.share-item + .share-item {
					margin-left: 12px;
				}
				.lang {
					margin: 0 30px;
					text-transform: capitalize;
					cursor: pointer;
					@extend .regular-14px;
				}
				.set {
					height: 18px;
					cursor: pointer;
					img {
						display: block;
						height: 100%;
						width: auto;
					}
				}
			}
		}
	}
}
.menuBtn {
	display: none;
}
.forMobile {
	display: none;
}

@media only screen and (max-width: 959px) {
	.forMobile {
		display: block;
	}
	.header {
		padding: 12px 20px;
		.header-wrap-new {
			display: none;
		}
	}
	.header .header-wp {
		display: flex;
		padding: 0;
	}
	.header .header-wp .logo {
		height: 36px;
		margin-right: 0;
	}
	.header .header-wp .hd-r {
		display: none;
		position: fixed;
		top: 60px;
		left: 0;
		width: 100%;
		height: calc(100vh - 60px);
		background-color: #fff;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		overflow-y: auto;
	}
	.header .header-wp .hd-r.show {
		display: block;
	}
	.header .header-wp .hd-r .nav {
		display: block;
	}
	.header .header-wp .hd-r .nav .nav-item {
		display: block;
		text-align: center;
	}
	.header .header-wp .hd-r .nav .nav-item + .nav-item {
		margin-left: 0;
		margin-top: 60px;
	}
	.header .header-wp .hd-r .tools .set {
		display: none;
	}
	.lang {
		position: fixed;
		top: 19px;
		right: 60px;
		z-index: 90;
	}
	.header .header-wp .hd-r .tools .lang {
		display: none;
	}
	.header .header-wp .hd-r .tools {
		margin-top: 60px;
		justify-content: center;
	}
	.menuBtn {
		display: block;
		background: url('~@/assets/images/menu.svg') no-repeat center center / 20px;
		width: 30px;
		height: 36px;
		cursor: pointer;
		position: absolute;
		right: 20px;
		top: 12px;
	}
	.menuBtn.open {
		background-image: url(~@/assets/images/close.svg);
	}
}
</style>